module.exports = __webpack_public_path__ + "img/yacht.1ea7e59d.jpg";